module.exports = "../static/media/watermark.323a8a8d.png";